import { useContext, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router';

import { setAuthToken, setOtpVerified } from '@actions/sessionActions';
import styles from '@components/auth/LoginSuccessPage.module.css';
import Icon from '@components/text/Icon';
import { sessionContext } from '@context/SessionStore';
import useLazyQueryWithPromise from '@hooks/useLazyQueryWithPromise';
import { GetMeDocument, GetMeQuery, GetMeQueryVariables } from '@typing/Generated';

const LoginSuccessPage = () => {
  const history = useHistory();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const jwtParam = params.get('jwt');

  const { dispatch, sessionState } = useContext(sessionContext);
  const authToken = sessionState.authToken;

  const getMe = useLazyQueryWithPromise<GetMeQuery, GetMeQueryVariables>(GetMeDocument);

  useEffect(() => {
    if (jwtParam && jwtParam !== authToken) {
      getMe({ context: { authToken: jwtParam }, fetchPolicy: 'network-only' }).then(response => {
        const user = response.data.me;

        if (user) {
          dispatch(setAuthToken(jwtParam, user));

          if (user.__typename === 'Client' && user.verificationPhoneNumber?.verified) {
            dispatch(setOtpVerified(false));
          }

          const storedPathname = sessionStorage.getItem('postLoginRedirectTo');
          sessionStorage.removeItem('postLoginRedirectTo');

          if (storedPathname) {
            history.push(storedPathname);
          } else {
            if (user.__typename === 'Admin') {
              history.push('/admin');
            } else if (user.__typename === 'Client') {
              history.push('/client');
            } else {
              history.push('/expert');
            }
          }
        }
      });
    }
  }, [authToken, dispatch, getMe, history, jwtParam]);

  return (
    <Icon
      ariaLabelKey="accessibility.ariaLabels.loading"
      className={styles.spinner + ' ' + styles.center}
      icon="spinner"
    />
  );
};

export default LoginSuccessPage;
